export const PostAccountStepId = {
  // Backend-tracked steps (synced with API)
  InitActivation: 'init_activation',
  HowIsIntegrated: 'how_is_integrated',
  TaxesDescription: 'taxes_description',
  AccIbanOnInvoices: 'acc_iban_on_invoices',
  IssueCard: 'issue_card',
  CardToWallet: 'card_to_wallet',
  TopUp: 'top_up',
  ReadyToGo: 'ready_to_go',

  // UI-only steps (no backend tracking)
  CardDesign: 'card_design',
  YourCardReady: 'your_card_ready',
} as const;

// All post-account step IDs type (backend + UI-only)
type PostAccountStepIdType =
  typeof PostAccountStepId[keyof typeof PostAccountStepId];

// Keys that are backend-tracked for type
type BackendStepKey =
  | 'InitActivation'
  | 'HowIsIntegrated'
  | 'TaxesDescription'
  | 'AccIbanOnInvoices'
  | 'IssueCard'
  | 'CardToWallet'
  | 'TopUp'
  | 'ReadyToGo';

// Backend-tracked step IDs only - use for API calls
export type BackendActivationStepIdType =
  typeof PostAccountStepId[BackendStepKey];

// Array of backend-tracked step IDs for runtime checks
export const BACKEND_ACTIVATION_STEP_IDS: readonly BackendActivationStepIdType[] =
  [
    PostAccountStepId.InitActivation,
    PostAccountStepId.HowIsIntegrated,
    PostAccountStepId.TaxesDescription,
    PostAccountStepId.AccIbanOnInvoices,
    PostAccountStepId.IssueCard,
    PostAccountStepId.CardToWallet,
    PostAccountStepId.TopUp,
    PostAccountStepId.ReadyToGo,
  ] as const;

// All valid step IDs (for validation)
export const ALL_ACTIVATION_STEP_IDS: readonly PostAccountStepIdType[] = [
  ...BACKEND_ACTIVATION_STEP_IDS,
  PostAccountStepId.CardDesign,
  PostAccountStepId.YourCardReady,
] as const;

// ===========================
// ONLY PURE HELPER FUNCTIONS BELOW
// ===========================

/** Check if a step ID is backend-tracked (type guard) */
export const isBackendTrackedStep = (
  stepId: string,
): stepId is BackendActivationStepIdType => {
  return BACKEND_ACTIVATION_STEP_IDS.includes(
    stepId as BackendActivationStepIdType,
  );
};

/** Check if a step ID is valid (exists in step definitions) */
export const isValidActivationStepId = (
  stepId: string,
): stepId is PostAccountStepIdType => {
  return ALL_ACTIVATION_STEP_IDS.includes(stepId as PostAccountStepIdType);
};
